"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = void 0;
const host_modules_1 = require("@wix/sdk-runtime/host-modules");
exports.i18n = (0, host_modules_1.createHostModule)({
    getLanguage: (host) => () => {
        const language = host.essentials?.language;
        if (!language) {
            throw new Error('Host language is not available on the current host. Make sure to use an updated version of the host initialization pacakge.');
        }
        return language;
    },
    getLocale: (host) => () => {
        const locale = host.essentials?.locale;
        if (!locale) {
            throw new Error('Host locale is not available on the current host. Make sure to use an updated version of the host initialization pacakge.');
        }
        return locale;
    },
});
